<template>
  <div class="py-3">
    <div class="row">
      <div v-if="loading" class="col-12 d-flex justify-content-center">
        <span
          class="text-center loadingres mr-1 ml-1 spinner-border loading-spinner"
        ></span>
      </div>

      <div class="col-sm-8" v-if="!loading">
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="key">
            <div class="pb-4 max-content">
              <StatsTable
                :statsClient="statsClient[parent.parent_name]"
                :statsType="getStatsTypeByParent(parent.parent_name)"
                :statsDate="statsDate"
                :showTotal="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-4" v-if="!loading">
        <div v-for="warning in warning_headers" :key="warning.id">
          <h4 class="ml-3 font-weight-bold">{{ warning.title }}</h4>

          <div v-for="diag in diagnostic" :key="diag.id" class="col-12">
            <div
              v-if="warning.keys.includes(diag.warning_type)"
              class="col-12 d-flex mt-4 mb-4"
            >
              <i class="h3 mr-3 text-bold icon-warning text-warning"></i>

              <p
                class="align-items-center"
                v-html="
                  $t('lang.warning.' + diag.warning_type, {
                    warning_value: diag.warning_value,
                    warning_trigger: diag.warning_trigger,
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { targetsService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";

export default {
  props: {
    targetId: String,
  },
  components: {
    StatsTable,
  },
  data() {
    return {
      statsClient: {},
      statsClientER_1: {},
      statsClientER_2: {},
      statsClientER_3: {},
      statsClientER_4: {},
      statsClientSPMCHK: {},

      statsType: {},
      statsDate: [],
      loading: true,
      warning_headers: [
        {
          title: "Sending Alerts",
          keys: [
            "newprospects_first_prc",
            "touchpoint_avg",
            "delay_1_2_avg",
            "delay_2_3_avg",
            "contact_age_avg",
          ],
        },
        {
          title: "Audience Alerts",
          keys: [
            "er_manualpositive_prc",
            "er_wrong_prc",
            "er_notscope_prc",
            "similar_contacts_avg",
            "opt_out_avg",
          ],
        },
        {
          title: "Deliverability Alerts",
          keys: ["deliver_ews_avg", "deliver_gmail_avg"],
        },
      ],
      diagnostic: [],
      parents: [],
      statsType: [
        {
          id: "total_sent",
          label: "Total sent",
          format: "qty",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "new_emails",
          label: "New prospects",
          format: "qty",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "new_emails_target",
          label: "New prospects obj.",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "glb_ideal_touchpoint",
          label: "Global ideal touchpoint",
          format: "avg",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "touchpoint",
          label: "Campaign AVG touchpoint",
          format: "avg",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "glb_contact_age",
          label: "Global prospects age",
          format: "avg",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "contact_age",
          label: "Campaign prospects age",
          format: "avg",
          showQty: false,
          showTotal: true,
          parent: "sent",
        },
        {
          id: "glb_response",
          label: "Global MAR",
          format: "rate",
          showQty: false,
          showTotal: true,
          parent: "response",
        },
        {
          id: "response",
          label: "Campaign MAR",
          format: "rate",
          showQty: false,
          showTotal: true,
          parent: "response",
        },
        {
          id: "glb_er_manualpositive",
          label: "Global Manual positive",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_manualpositive",
        },
        {
          id: "er_manualpositive",
          label: "Manual positive",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_manualpositive",
        },
        {
          id: "glb_er_wrong",
          label: "Global wrong",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_wrong",
        },
        {
          id: "er_wrong",
          label: "Campaign wrong",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_wrong",
        },
        {
          id: "glb_er_notscope",
          label: "Global not scope",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_notscope",
        },
        {
          id: "er_notscope",
          label: "Campaign not scope",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_notscope",
        },
        {
          id: "glb_er_negative",
          label: "Gloabl negative",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_negative",
        },
        {
          id: "er_negative",
          label: "Campaign negative",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_negative",
        },
        {
          id: "glb_er_introduction",
          label: "Gloabl introduction",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_introduction",
        },
        {
          id: "er_introduction",
          label: "Campaign introduction",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_introduction",
        },
        {
          id: "glb_er_urgent",
          label: "Gloabl urgent",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_urgent",
        },
        {
          id: "er_urgent",
          label: "Campaign urgent",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_urgent",
        },
        {
          id: "glb_er_donotcontact",
          label: "Gloabl do not contact",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_donotcontact",
        },
        {
          id: "er_donotcontact",
          label: "Campaign do not contact",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "er_donotcontact",
        },
        {
          id: "ews_deliver",
          label: "EWS CHECK",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "spam_check",
        },
        {
          id: "gmail_deliver",
          label: "GMAIL CHECK",
          format: "percentage",
          showQty: false,
          showTotal: true,
          parent: "spam_check",
        },
      ],
    };
  },

  created() {
    targetsService.getDiagnostic(this.targetId).then((res) => {
      this.diagnostic = res["diagnostic"];

      if (res["diagnosticHistoric"] !== null) {
        res["diagnosticHistoric"].forEach((item) => {
          if (
            item.glb_total_sent_qty !== undefined &&
            item.glb_total_sent_qty !== null
          ) {
            item.glb_response_rate = this.getRate(
              item.glb_er_total_qty,
              item.glb_total_sent_qty
            );
          }
          if (
            item.total_sent_qty !== undefined &&
            item.total_sent_qty !== null
          ) {
            item.response_rate = this.getRate(
              item.er_total_qty,
              item.total_sent_qty
            );
          }
        });

        res["diagnosticHistoric"].forEach((item) => {
          const client_id = item.client_id;
          const client_name = item.client_name;
          const fdate = item.fdate;

          if (!this.statsDate.find((field) => field.date == fdate)) {
            this.statsDate.push({ date: fdate });
          }

          this.statsType.forEach((statType) => {
            let type = statType.id + "_" + statType.format;
            let parent = statType.parent;

            if (!this.parents.find((field) => field.parent_name == parent)) {
              this.parents.push({ parent_name: parent });
            }

            if (this.statsClient[parent] == undefined) {
              this.statsClient[parent] = {};
            }
            if (this.statsClient[parent][client_id] == undefined) {
              this.statsClient[parent][client_id] = {};
              this.statsClient[parent][client_id]["name"] = client_name;
            }
            if (this.statsClient[parent][client_id][fdate] == undefined) {
              this.statsClient[parent][client_id][fdate] = item;
            }

            if (item[type] !== undefined && item[type] !== null) {
              if (this.statsClient[parent][client_id][type] === undefined) {
                this.statsClient[parent][client_id][type] = 0;
                this.statsClient[parent][client_id][type + "_total"] = 0;
              }
              this.statsClient[parent][client_id][type] += parseFloat(
                item[type]
              );
              this.statsClient[parent][client_id][type + "_total"]++;
            }
          });
        });

        this.statsDate.sort((a, b) => a.date - b.date);

        this.statsType.forEach((statType) => {
          let type = statType.id + "_" + statType.format;
          let parent = statType.parent;
          if (["avg", "percentage", "rate"].includes(statType.format)) {
            // arreglar promedio

            this.statsClient[parent][0][type] =
              this.statsClient[parent][0][type] /
              this.statsClient[parent][0][type + "_total"];
          }
        });
      }

      this.loading = false;
    });
  },
  methods: {
    getStatsTypeByParent(parent) {
      let x = this.statsType.filter((e) => e.parent === parent);
      return x;
    },
    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>